module.exports = __webpack_public_path__ + "img/patient.edf47b3f.svg";